// extracted by mini-css-extract-plugin
export default {"final":"Final_final__QBzN8"};